import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className='footer'>
            <p> 2020 © The Gram | <a href="https://www.instagram.com/arefat.hy/">Instagram</a> | All Rights Matter. - Photo Sharing Site with comments and captions, Project by <a href="http://github.com/arefathi" > Arefat Hyeredin</a> </p>
            <p>Account  ·   Photos   ·   Privacy   ·   Contact  </p>
        </div>
    )
}

export default Footer
